export default __webpack_public_path__ + "static/Scalable-and-Growth-Centric-a822e55d0c45687d01bc12644b9da88e.webp";